export default "__VITE_ASSET__B62dmsT1__"